exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RWXy-{height:100%;width:100%;position:absolute;-o-object-fit:cover;object-fit:cover}._1Ar_X{border-radius:5px}._2bvsy{position:relative;height:100%;width:100%;overflow:hidden}._3t7Ng{border-radius:5px}._2bvsy:hover img{-webkit-transform:scale(1.1);transform:scale(1.1);transition:all .3s ease-in-out}._2IZoB{position:absolute;bottom:0;z-index:9;margin:16px;margin:1rem;font-size:21.76px;font-size:1.36rem;white-space:normal}.TQxMN{font-size:28.8px;font-size:1.8rem}._1pfFu{position:absolute;height:100%;width:100%;background-image:linear-gradient(0deg,#000,transparent);z-index:8}", ""]);

// exports
exports.locals = {
	"articles__img": "RWXy-",
	"img_round": "_1Ar_X",
	"cardContainer": "_2bvsy",
	"mobileBanner": "_3t7Ng",
	"cardTitle": "_2IZoB",
	"desktop_font_size": "TQxMN",
	"cardGradient": "_1pfFu"
};